import { CategoryData } from '../index'

export default function CategoryDataFunc() {
  return CategoryData()
}
